module.exports = __webpack_public_path__ + "static/costplanning-65edf53f55bb029c9b10dcf2b177d06c.png";